import React, { useState } from 'react';
import BaseSidebarPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/BaseSidebarPanel';
import MultiStylePropertyPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/style-inputs/MultiStylePropertyPanel';
import TinyMCEEditor from '../tinymce';
import RichTextBlock from './index';
export default function RichTextSidebarPanel({ data, setData }) {
    var _e, _t;
    const [, setErrors] = useState(null);
    const updateData = (d) => {
        const res = RichTextBlock.schema.safeParse(d);
        if (res.success == true) {
            setData(res.data);
            setErrors(null);
        }
        else {
            setErrors(res.error);
        }
    };
    return (React.createElement(BaseSidebarPanel, { title: "RichText block" },
        React.createElement(TinyMCEEditor, { value: (_t = (_e = data.props) === null || _e === void 0 ? void 0 : _e.text) !== null && _t !== void 0 ? _t : '', onChange: (text) => updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { text }) })) }),
        React.createElement(MultiStylePropertyPanel, { names: ['color', 'backgroundColor', 'fontFamily', 'fontSize', 'fontWeight', 'textAlign', 'padding'], value: data.style, onChange: (style) => updateData(Object.assign(Object.assign({}, data), { style })) })));
}
//# sourceMappingURL=RichTextSidebarPanel.js.map